import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { CSVString2Array } from '../../../Utilities/Utilities';
import ListSelection from '../../Licences/ListSelection';
import { id } from 'date-fns/locale';



const  ModulesFeaturesInformation = ({
    data, 
    onFieldChange, 
    flexLicenceTemplates, 
    modules = [],
    mainFeatures = [],
    CFFeatures = [],
    branding = [],
    presetWorkflows = [],
    correctivesFeatures = [],
    selectedMainFeatures = [],
    selectedCFFeatures = [],
    selectedBranding = [],
    selectedPresetWorkflows = [],
    selectedCorrectivesFeatures = []
        }) => {    //  const [row, setRow] = useState(LicenceData);
    
    const templates = flexLicenceTemplates.map((el) => {
        return el.name;
    });
    //console.log("Templates: ", flexLicenceTemplates);
    //console.log("presetWorkflows: ",presetWorkflows.map((a) => a.name).sort((a, b) => (a > b ? 1 : -1)));
    return (
        <div style={{width:800}}>
          
            { flexLicenceTemplates !== undefined && 
                <div style={{marginTop: "20px", marginLeft: "20px"}}>
                    <Autocomplete
                        id="flexLicenceTemplateName"
                        className="combobox"
                        autoHighlight={true}
                        disablePortal
                        noOptionsText="Licence Template"
                        value={data.flexLicenceTemplateName}
                        options={templates.sort((a,b) => a > b ? 1 : -1)}
                        onChange={(event, value, id) => onFieldChange(event, value, "flexLicenceTemplateName")}
                        renderInput={(params) => <TextField {...params} label="Licence Template" />}
                    />
                </div>
            }
             
                <div style={{marginTop: "20px", marginLeft: "20px"}}>
                    <ListSelection 
                    baseList={modules}
                    selectedList={CSVString2Array(data.modules).sort((a,b) => a > b ? 1 : -1)} 
                    title={"Modules"} 
                    id = "modules" 
                    onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                    />
                </div>
            
            {mainFeatures !== undefined &&
                <div style={{marginTop: "20px", marginLeft: "20px"}}>
                    <ListSelection 
                    baseList={mainFeatures.sort((a, b) => (a > b ? 1 : -1))} 
                    selectedList={selectedMainFeatures} 
                    title={"App Features"} 
                    id="features" 
                    onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                    />
                </div>
            }
            {CFFeatures !== undefined &&
                <div style={{marginTop: "20px", marginLeft: "20px"}}>
                    <ListSelection 
                    baseList={CFFeatures.sort((a, b) => (a > b ? 1 : -1))} 
                    selectedList={selectedCFFeatures} 
                    title={"Custom Field Templates"} 
                    id="cfTemplates" 
                    onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                    />
                </div>
            }
            {branding !== undefined &&
                <div style={{marginTop: "20px", marginLeft: "20px"}}>
                    <ListSelection 
                    baseList={branding.sort((a, b) => (a > b ? 1 : -1))} 
                    selectedList={selectedBranding} 
                    title={"Branding"} 
                    id="branding" 
                    onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                    />
                </div>
            }
            
                <div style={{marginTop: "20px", marginLeft: "20px"}}>
                    <ListSelection 
                    baseList={presetWorkflows.map(a => a.name).sort((a, b) => (a > b ? 1 : -1))} 
                    selectedList={selectedPresetWorkflows} 
                    title={"Preset Workflows"} 
                    id="presetWorkflows" 
                    onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                    />
                </div>
            
            {correctivesFeatures !== undefined &&
                <div style={{marginTop: "20px", marginLeft: "20px"}}>
                    <ListSelection 
                    baseList={correctivesFeatures.sort((a, b) => (a > b ? 1 : -1))} 
                    selectedList={selectedCorrectivesFeatures} 
                    title={"Correctives"} 
                    id="correctives" 
                    onSelectionChange={(event,value, id) => onFieldChange(event, value, id)} 
                    />
                </div>
            }
        </div>
    );
   
}

export default ModulesFeaturesInformation;